<template>
  <div
    class="loading-view w-screen h-screen flex flex-col items-center justify-center font-pixel overflow-hidden"
    :style="{ backgroundColor: '#4aa3a3', backgroundImage: `url(${desktopBackground})`, backgroundRepeat: 'repeat' }"
  >
    <!-- Retro loading box -->
    <div class="border-2 border-black bg-white shadow-pixel p-8 flex flex-col items-center">
      <p class="text-4xl font-bold text-black mb-4">Loading...</p>
      <!-- Progress bar track -->
      <div class="w-48 h-4 border-2 border-black bg-gray-200">
        <div
          class="h-full bg-black transition-all duration-100"
          :style="{ width: progress + '%' }"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import desktopBackground from '@/assets/desktop-bg2-924f1967-5752-4203-b00a-6c23628c74ea.png'

const emit = defineEmits(['complete'])

const progress = ref(0)
const duration = 2000
const interval = 30
const steps = duration / interval
const increment = 100 / steps
let progressTimer = null

onMounted(() => {
  progressTimer = setInterval(() => {
    progress.value = Math.min(progress.value + increment, 100)
  }, interval)
  setTimeout(() => {
    if (progressTimer) clearInterval(progressTimer)
    progress.value = 100
    emit('complete')
  }, duration)
})
</script>
